export { getProvinceAndCity }

/**
 * @functionName:getProvinceAndCity
 * @description:返回省市名称,并去掉结尾的‘省’,‘市’
 * @param {String} province
 * @param {String} city
 * @return {Object} province and city
 */
function getProvinceAndCity(province, city) {
  province = province&&province.replace(/[省市]$/, '')
  city = city&&city.replace(/[省市]$/, '')
  const municipality = new Set(['上海', '重庆', '北京', '天津'])
  city = municipality.has(province) ? province : city
  return { province, city }
}
